import "./App.css";
import AppRoutes from "./routes/route";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getUserFromStorage } from "./utils/auth";
import ResponsiveCourseNavnarForDivices from "./component/NavBar/ResponsiveNavbarForDivices";
import { useEffect, useState } from "react";
import { setUser } from "./redux/slices/userSlice";
import { useDispatch } from "react-redux";
import Footer from "./component/NavBar/Footer";
import axios from "axios";
import endpoints from "./endpoint";
import Loader from "./comman/Loader";
import { generateToken, messaging } from "./firebase/firebase";
import { onMessage } from "firebase/messaging";
import WhatsAppFloatingButton from "./Pages/WhatsAppFloatingButton";

function App() {
  const location = useLocation();
  const getuser = getUserFromStorage();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [fcmToken, setFcmToken] = useState(null);
  const [showNotificationPrompt, setShowNotificationPrompt] = useState(false);

  // ✅ Request Notification Permission at the Right Time
  useEffect(() => {
    const checkNotificationPermission = async () => {
      if (Notification.permission === "default") {
        // Show custom UI prompt to ask the user
        setShowNotificationPrompt(true);
      }
    };

    checkNotificationPermission();
  }, []);

  const handleEnableNotifications = async () => {
    setShowNotificationPrompt(false);
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      // Register service worker and get FCM token
      try {
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );
        await navigator.serviceWorker.ready;
        const token = await generateToken();
        setFcmToken(token);
        console.log("FCM Token:", token);
      } catch (error) {
        console.error("❌ Service Worker Registration Failed:", error);
      }
    } else {
      console.log("❌ Notifications denied by user");
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          endpoints.serverBaseUrl + "api/user/verify",
          { withCredentials: true }
        );
        if (response?.data?.success) {
          sessionStorage.setItem("token", response?.data?.token);
          sessionStorage.setItem("user", JSON.stringify(response?.data?.user));
          dispatch(setUser(response?.data?.user));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    if (!getuser?.token) {
      fetchUser();
    }
    handleEnableNotifications();
  }, [getuser?.token, dispatch]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");

    if (ref) {
      sessionStorage.setItem("referralPartner", ref);
    }
  }, [location]);

  useEffect(() => {
    const user = getUserFromStorage();
    dispatch(setUser(user));

    const redirectPath = sessionStorage.getItem("redirectPath");
    if (user && redirectPath) {
      navigate(redirectPath, { replace: true });
      setTimeout(() => sessionStorage.removeItem("redirectPath"), 100);
    }
  }, [dispatch, navigate]);

  const routesWithoutNavbar = [
    "/experts",
    "/password/forgot",
    "/dashboard",
    "/",
  ];

  const dynamicPurchasedVideosPath =
    /^\/student\/purchased\/[a-zA-Z0-9]+\/videos/;
  const isDynamicPurchasedVideosPath = dynamicPurchasedVideosPath.test(
    location.pathname
  );
  const isStaticPath = routesWithoutNavbar.some((route) =>
    location.pathname.startsWith(route)
  );

  const shouldHideNavbar =
    isDynamicPurchasedVideosPath ||
    (isStaticPath &&
      location.pathname !== "/" &&
      location.pathname !== "/market" &&
      location.pathname !== "/student/purchased" &&
      location.pathname !== "/expert" &&
      location.pathname !== "/student/cart" &&
      location.pathname !== "/contactUs" &&
      location.pathname !== "/strategypurchased" &&
      location.pathname !== "/termsconditon");

  if (loading && !getuser?.token) return <Loader />;

  return (
    <div className="App">
      {!shouldHideNavbar && <ResponsiveCourseNavnarForDivices />}
      <main>
        <Outlet />
      </main>
      <AppRoutes />
      {!shouldHideNavbar && <Footer />}
      <WhatsAppFloatingButton />
      {/* ✅ Custom Notification Prompt */}
      {/* {showNotificationPrompt && (
        <div className="fixed bottom-6 right-6 md:bottom-12 md:right-12 bg-gradient-to-r from-blue-600 to-blue-800 shadow-xl p-4 md:p-5 rounded-xl text-white flex items-center space-x-3 md:space-x-4 animate-fade-in max-w-xs md:max-w-md w-full">
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-6 h-6 md:w-8 md:h-8 text-yellow-400 flex-shrink-0"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 2m-3 6a9 9 0 100-18 9 9 0 000 18z"
              />
            </svg>
            <div className="flex-1">
              <p className="text-sm md:text-lg font-semibold">Stay Ahead in the Market!</p>
              <p className="text-xs md:text-sm opacity-80">
                Enable notifications to receive real-time trading insights & updates.
              </p>
            </div>
          </div>
          <button
            onClick={handleEnableNotifications}
            className="bg-yellow-400 text-blue-900 px-3 md:px-4 py-1.5 md:py-2 rounded-lg font-medium hover:bg-yellow-300 transition duration-300 text-xs md:text-sm"
          >
            Enable Now
          </button>
        </div>
      )} */}
    </div>
  );
}

export default App;
